export default __webpack_public_path__ + "static/media/Btn1.55daff01.png";